"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueKey = exports.discountOnMapper = void 0;
const discount_enums_1 = require("../../../payment/types/enums/discount.enums");
exports.discountOnMapper = {
    [discount_enums_1.DiscountOnEnum.ITEM]: discount_enums_1.InvoiceDiscountOnEnum.LINE_ITEM,
    [discount_enums_1.DiscountOnEnum.ALL]: discount_enums_1.InvoiceDiscountOnEnum.INVOICE,
};
/**
 * Generates a unique key for a given cart item.
 */
const getUniqueKey = (entity) => {
    return entity.id?.toString() ?? entity.unique;
};
exports.getUniqueKey = getUniqueKey;
//# sourceMappingURL=invoice.consts.js.map